import { useEffect, useReducer, useState } from "react";
import { Icon } from "../components/Icon.js";
import { clearTtsLog, formatTtsLog, subscribeTtsLog } from "../lib/ttsLog.js";

/**
 * A small on-page console for Read Aloud. Toggle it, press Read aloud, then Copy
 * the log to see exactly what narration did (chunk count/size, provider, audio
 * durations, where it advanced). Diagnostic only.
 */
export function TtsConsole() {
  const [open, setOpen] = useState(false);
  const [, bump] = useReducer((n: number) => n + 1, 0);
  const [copied, setCopied] = useState(false);

  useEffect(() => subscribeTtsLog(bump), []);

  const text = formatTtsLog();

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(text || "(empty)");
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      // Fallback: select-all in a temporary textarea.
      const ta = document.createElement("textarea");
      ta.value = text;
      document.body.appendChild(ta);
      ta.select();
      try {
        document.execCommand("copy");
        setCopied(true);
        setTimeout(() => setCopied(false), 1500);
      } catch {
        /* ignore */
      }
      ta.remove();
    }
  };

  if (!open) {
    return (
      <button className="tts-console-fab" title="Show the Read Aloud debug log" onClick={() => setOpen(true)}>
        <Icon name="volume" size={13} /> TTS log
      </button>
    );
  }

  return (
    <div className="tts-console">
      <div className="tts-console-head">
        <strong>Read Aloud log</strong>
        <div className="row gap-1" style={{ marginLeft: "auto" }}>
          <button className="btn btn-sm" onClick={copy}>
            <Icon name={copied ? "check" : "file"} size={13} /> {copied ? "Copied" : "Copy"}
          </button>
          <button className="btn btn-sm btn-ghost" onClick={() => clearTtsLog()}>Clear</button>
          <button className="btn btn-icon btn-ghost btn-sm" title="Hide" onClick={() => setOpen(false)}>
            <Icon name="x" size={14} />
          </button>
        </div>
      </div>
      <pre className="tts-console-body">{text || "(no events yet — press Read aloud)"}</pre>
    </div>
  );
}
